import { Component, Input } from '@angular/core';
import { SvgIconSizeMod } from 'models/layout-mod.model';

@Component({
  selector: 'app-form-row',
  templateUrl: './form-row.component.html',
  styleUrls: ['./form-row.component.scss']
})
export class FormRowComponent {
  @Input() label? = '';
  @Input() tooltipText? = '';

  constructor() { }

  protected readonly svgIconSizeMod = SvgIconSizeMod;
}
